import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { exchangeCodeForToken } from './tokenExchange';

function CallbackHandler() {

  console.log('CallbackHandler called');
  const navigate = useNavigate();
  const { login } = useAuth();
  const tokenExchangeAttempted = React.useRef(false);
  
  useEffect(() => {

    const handleCallback = async () => {
        if (tokenExchangeAttempted.current) return;
        tokenExchangeAttempted.current = true;
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
  
        if (code) {
          const success = await exchangeCodeForToken(code);
          if (success) {
            await login();
            console.log('Login successful, navigating to /meetings');
            navigate('/meetings', { replace: true });
          } else {
            console.log('Login failed, navigating to /');
            navigate('/', { replace: true });
          }
        } else {
          console.error('No code found in URL');
          navigate('/');
        }
      };

      handleCallback();
  
  }, [navigate, login]);

  return <div>Processing authentication...</div>;
}

export default CallbackHandler;
